// Generated by LiveScript 1.6.0
var ref$, id, log, delay, toIxChain, pub, sub, pushState, getWidgetAtDom, Scroller, IS_LOCALHOST, NO_AUTOSCROLLING, NO_DEEPLINKING, pokeScroller;
ref$ = require('utils'), id = ref$.id, log = ref$.log, delay = ref$.delay;
toIxChain = require('../widgets/servd/functions').toIxChain;
ref$ = require('pubsub'), pub = ref$.pub, sub = ref$.sub;
pushState = require('history').pushState;
getWidgetAtDom = require('../widgets').getWidgetAtDom;
Scroller = require('../scroller');
IS_LOCALHOST = window.location.toString().indexOf('localhost') > -1;
NO_AUTOSCROLLING = true && IS_LOCALHOST;
NO_DEEPLINKING = true && IS_LOCALHOST;
pokeScroller = {
  fn: id
};
global.servdCallback = function(menu){
  return pokeScroller.fn(menu);
};
module.exports = function($page, $$){
  var scroller, servd, scrollState, rescrollToTargetSection;
  log('HomeController::init');
  scroller = new Scroller();
  servd = getWidgetAtDom($$('[data-widget="servd"]'));
  scrollState = {
    targetSection: "",
    userScrolled: false,
    servdLoaded: false
  };
  scroller.onSectionChange(function(section, $section){
    return Nav.invert($section.data('invert-navicon') != null);
  });
  rescrollToTargetSection = function(section){
    if (section) {
      scrollState.targetSection = section;
    }
    if (!scrollState.userScrolled) {
      log('rescrolling', scrollState.targetSection);
      return scroller.scrollToIfDifferent(scrollState.targetSection);
    } else {
      return log('skipping scroll because user has already scrolled');
    }
  };
  if (NO_AUTOSCROLLING) {
    log('NO_AUTOSCROLLING');
  } else {
    pokeScroller.fn = function(){
      return scroller.readInitialUrl(true);
    };
    scrollState.targetSection = scroller.readInitialUrl();
    if (servd != null) {
      servd.onServdFetchComplete(function(){
        scrollState.servdLoaded = true;
        return rescrollToTargetSection();
      });
    }
    $(document).on('wheel', function(){
      return scrollState.userScrolled = true;
    });
  }
  if (NO_DEEPLINKING) {
    log('NO_DEEPLINKING');
  } else {
    sub('section-changed', function(section){
      scrollState.targetSection = section;
      return pushState([section]);
    });
    sub('history-pop', function(urlParts){
      rescrollToSection(urlParts[0]);
      if (urlParts[0] === 'menu' && urlParts.length > 1) {
        return pub('menu-display', toIxChain(urlParts[1]));
      }
    });
    sub('history-push', function(urlParts){
      if (urlParts[0] === 'menu' && urlParts.length > 1) {
        return pub('menu-display', toIxChain(urlParts[1]));
      }
    });
  }
  return $('body').on('click', '[data-scroll-to]', function(event){
    log("GlobalPageController::on-scrollable-click - pushing state", $(this).data('scroll-to'));
    scrollState.targetSection = $(this).data('scroll-to');
    pushState([scrollState.targetSection]);
    scroller.scrollTo(scrollState.targetSection);
    event.preventDefault();
    return false;
  });
};
//# sourceMappingURL=data:application/json;base64,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

